import { Selector } from '@ngxs/store';

import { NavigationState, NavigationStateModel } from './navigation.state';

export class NavigationSelectors {
    @Selector([NavigationState])
    static menu(model: NavigationStateModel) {
        return model.menu;
    }

    @Selector([NavigationState])
    static userMenu(model: NavigationStateModel) {
        return model.userMenu;
    }
}
